import {
  Breakpoints,
  Carousel,
  useMediaQuery,
} from '@leland-dev/leland-ui-library';
import { type StaticImageData } from 'next/image';
import React, { forwardRef } from 'react';

import { type Scalars } from '../../../__generated-gql-types__/globalTypes';
import ApplyTexasImage from '../../../assets/images/college-featured-images/ApplyTexas.png';
import CommonAppImage from '../../../assets/images/college-featured-images/CommonApp.png';
import TopEngineeringImage from '../../../assets/images/college-featured-images/EngineeringSchools.png';
import IvyLeagueImage from '../../../assets/images/college-featured-images/IvyLeague.png';
import UCSImage from '../../../assets/images/college-featured-images/UCs.png';
import UtahSchoolsImage from '../../../assets/images/college-featured-images/UtahSchools.png';
import {
  COLLEGE_CATEGORY_URN,
  FEATURED_FILTERS,
  FEATURED_FILTERS_ITEMS,
  FEATURED_SCHOOL_FILTERS,
  FEATURED_SCHOOL_FILTERS_SCHOOL_NAMES,
} from '../../../utils/constants';
import { FeaturedFilterCard } from '../FeaturedFilterCard';

const FEATURED_SCHOOL_FILTERS_IMAGES: Record<
  FEATURED_SCHOOL_FILTERS,
  StaticImageData
> = Object.freeze({
  [FEATURED_SCHOOL_FILTERS.IVY]: IvyLeagueImage,
  [FEATURED_SCHOOL_FILTERS.COMMON_APP]: CommonAppImage,
  [FEATURED_SCHOOL_FILTERS.UCS]: UCSImage,
  [FEATURED_SCHOOL_FILTERS.UTAH_SCHOOLS]: UtahSchoolsImage,
  [FEATURED_SCHOOL_FILTERS.TOP_ENGINEERING]: TopEngineeringImage,
  [FEATURED_SCHOOL_FILTERS.APPLY_TEXAS]: ApplyTexasImage,
});

interface BrowsePopularCollegeSchoolsProps {
  onClick?: (
    urns: Array<Scalars['SchoolUrn']['output']>,
    label: string,
  ) => void;
}

export const BrowsePopularCollegeSchools = forwardRef<
  HTMLDivElement,
  BrowsePopularCollegeSchoolsProps
>(function BrowsePopularSchoolsRenderFn({ onClick }, ref) {
  const isLg = useMediaQuery(Breakpoints.LG);
  const isMd = useMediaQuery(Breakpoints.MD);

  return (
    <div className="w-full" ref={ref}>
      <Carousel
        swiperProps={{
          slidesPerGroupAuto: false,
          slidesPerView: isLg ? 4 : isMd ? 3 : 1.15,
          spaceBetween: 16,
        }}
        title="Browse by most popular schools"
        items={FEATURED_FILTERS[COLLEGE_CATEGORY_URN].map((filter) => (
          <FeaturedFilterCard
            key={filter}
            title={FEATURED_SCHOOL_FILTERS_SCHOOL_NAMES[filter]}
            image={FEATURED_SCHOOL_FILTERS_IMAGES[filter]}
            onClick={() => {
              onClick?.(FEATURED_FILTERS_ITEMS[filter], filter);
            }}
          />
        ))}
        disableArrowGradient
      />
    </div>
  );
});
